//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface CustomException {
    duration?: number;
    message?: string;
    type?: ExceptionTypeEnum;
}

export enum ExceptionTypeEnum {
    Error = 0,
    Warning = 1,
}

export interface AuthenticatedResponse {
    token?: string | undefined;
}

export interface LoginRequestModel {
    email?: string;
    password?: string;
}

export interface ConfirmResetPasswordRequestModel {
    password?: string;
    confirmPassword?: string;
    token?: string;
}

export interface RequestResetPasswordRequestModel {
    email?: string;
}

export interface AcceptTermsRequestModel {
    token?: string;
    accepted?: boolean;
}

export interface CommitRequest {
    siteId?: number;
    fileName?: string;
    extraction?: any;
}

export interface ImportDecisionsVM {
    series?: SeriesDecision[];
    confirmNewSites?: boolean;
}

export interface SeriesDecision {
    seriesId?: string;
    include?: boolean;
    siteId?: number | undefined;
    newSiteName?: string | undefined;
    newSitePortalId?: number | undefined;
    newPortalName?: string | undefined;
    logicalGroupId?: number | undefined;
    newLogicalGroupName?: string | undefined;
    categoryId?: number | undefined;
}

export interface LiveDisplayOverviewVM {
    locationId?: string;
    name?: string;
    utilityType?: string;
    unit?: string | undefined;
    siteId?: number;
    isMapped?: boolean;
    hasCurrentPower?: boolean;
    hasEnergy?: boolean;
    currentKw?: number | undefined;
    yesterdaySameTimeKw?: number | undefined;
    todayValue?: number | undefined;
    baselineSameTimeValue?: number | undefined;
    differenceValue?: number | undefined;
    changePercent?: number | undefined;
    todayCost?: number | undefined;
    baselineCost?: number | undefined;
    differenceCost?: number | undefined;
    currency?: string | undefined;
    unitCost?: number | undefined;
    baselineDate?: Date | undefined;
    lastUpdated?: Date | undefined;
    valueDataThrough?: string | undefined;
    status?: string;
    statusMessage?: string | undefined;
    todayCumulativeTrend?: TrendPointVM[];
    baselineCumulativeTrend?: TrendPointVM[];
    todayEnergyKwh?: number | undefined;
    lastWeekSameTimeEnergyKwh?: number | undefined;
    yesterdayEnergySameTimeKwh?: number | undefined;
    energyDataThrough?: string | undefined;
}

export interface TrendPointVM {
    time?: string;
    value?: number | undefined;
}

export interface LiveDisplayLocationVM {
    locationId?: string;
    name?: string;
    utilityType?: string;
    unit?: string | undefined;
    siteId?: number;
    isMapped?: boolean;
    hasCurrentPower?: boolean;
    hasEnergy?: boolean;
    currentKw?: number | undefined;
    yesterdaySameTimeKw?: number | undefined;
    todayValue?: number | undefined;
    baselineSameTimeValue?: number | undefined;
    differenceValue?: number | undefined;
    changePercent?: number | undefined;
    todayCost?: number | undefined;
    baselineCost?: number | undefined;
    differenceCost?: number | undefined;
    currency?: string | undefined;
    unitCost?: number | undefined;
    baselineDate?: Date | undefined;
    lastUpdated?: Date | undefined;
    valueDataThrough?: string | undefined;
    status?: string;
    statusMessage?: string | undefined;
    todayCumulativeTrend?: TrendPointVM[];
    baselineCumulativeTrend?: TrendPointVM[];
    todayEnergyKwh?: number | undefined;
    lastWeekSameTimeEnergyKwh?: number | undefined;
    yesterdayEnergySameTimeKwh?: number | undefined;
    energyDataThrough?: string | undefined;
}

export interface LiveDisplayTrendVM {
    locationId?: string;
    name?: string;
    utilityType?: string;
    siteId?: number;
    metricType?: string;
    unit?: string | undefined;
    today?: TrendPointVM[];
    baseline?: TrendPointVM[];
    yesterday?: TrendPointVM[];
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface KioskTokenResponseVM {
    token?: string;
    siteId?: number;
    kioskId?: string;
    expiresInSeconds?: number;
}

export interface KioskTokenRequestVM {
    deviceKey?: string;
}

export interface SaveSiteMicResponseVM {
    mic?: SiteMicVM;
    hoursAtOrOverMic?: number | undefined;
}

export interface SiteMicVM {
    micKva?: number;
    enteredUtc?: Date;
    enteredBy?: string | undefined;
}

export interface SaveSiteMicRequestVM {
    siteId?: number;
    micKva?: number;
    windowFrom?: Date | undefined;
    windowTo?: Date | undefined;
}

export interface PortalVM {
    portalId?: number;
    name?: string;
    logoId?: number | undefined;
}

export interface SiteVM {
    siteId?: number;
    name?: string;
    description?: string;
}

export interface LogoVM {
    portalLogos?: string[];
    siteLogos?: string[];
}

export interface FPCategoryVM {
    fpcategoryId?: number;
    categoryName?: string;
    adminName?: string;
    description?: string;
    locationId?: string;
    showFormat?: string;
    defaultFormat?: string;
    report?: ReportVM;
    fpicon?: FPIconVM;
    groups?: GroupVM[];
    order?: number;
    allowWhatIf?: boolean;
}

export interface ReportVM {
    reportId?: number;
    reportUrl?: string;
}

export interface FPIconVM {
    fpiconId?: number;
    iconPath?: string;
}

export interface GroupVM {
    id?: number;
    name?: string;
    type?: string;
    resourceType?: GroupResourceType;
    readingTypeId?: number | undefined;
    monitoringSourceType?: MonitoringSourceType;
    isConfigured?: boolean;
    canReviewMonitoringSource?: boolean | undefined;
    isCalculatedMeasurement?: boolean | undefined;
    reviewLogicalGroupId?: number | undefined;
    reviewableContributorLogicalGroupIds?: number[];
    isDirectLogicalGroup?: boolean;
}

export enum GroupResourceType {
    Unknown = 0,
    LogicalGroup = 1,
    Policy = 2,
    PolicyGroup = 3,
}

export enum MonitoringSourceType {
    Unknown = 0,
    Live = 1,
    Static = 2,
}

export interface SiteWithCoordinatesVM {
    siteId?: number;
    name?: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export interface UpdateFPCategoryOrderRequest {
    siteId?: number;
    fpCategoryId?: number;
    locationId?: string;
    order?: number;
}

export interface LoggerHealthVM {
    healthStatusID?: number;
    sourceDeviceKey?: string;
    trvID?: number | undefined;
    siteID?: number | undefined;
    siteName?: string | undefined;
    loggerName?: string;
    vendorType?: string;
    latestFileReceivedDate?: Date | undefined;
    latestRawReadingDate?: Date | undefined;
    latestAggregatedReadingDate?: Date | undefined;
    currentStatus?: string;
    suspectedFailureStage?: string | undefined;
    lastAlertSentDate?: Date | undefined;
    updatedDate?: Date;
    gatewayKey?: string | undefined;
    deviceString?: string | undefined;
    meterName?: string | undefined;
    fpCategoryId?: number | undefined;
    fpCategoryName?: string | undefined;
    fpCategoryAdminName?: string | undefined;
    configuredName?: string | undefined;
    isShownInCustomerView?: boolean;
    logicalGroupID?: number | undefined;
    configRegister?: string | undefined;
    configReadingType?: string | undefined;
    configValueScale?: number | undefined;
    configAggregation?: string | undefined;
    configDescription?: string | undefined;
    configUnit?: string | undefined;
    monitoringSourceType?: number;
    isConfigured?: boolean;
}

export interface MonitoringSourceConfigItemVM {
    logicalGroupId?: number;
    name?: string;
    categoryName?: string;
    readingTypeId?: number | undefined;
    monitoringSourceType?: MonitoringSourceType;
    isConfigured?: boolean;
    isDerived?: boolean;
}

export interface SaveMonitoringSourcesRequestVM {
    siteId?: number;
    items?: SaveMonitoringSourceItemVM[];
}

export interface SaveMonitoringSourceItemVM {
    logicalGroupId?: number;
    monitoringSourceType?: MonitoringSourceType;
}

export interface MarkMonitoringSourceStaticRequestVM {
    siteId?: number;
    logicalGroupId?: number;
}

export interface TariffRateVM {
    kind?: string;
    name?: string;
    centPerKwh?: number;
    fromHour?: number | undefined;
    toHour?: number | undefined;
}

export interface SaveTariffRatesRequestVM {
    siteId?: number;
    rates?: TariffRateVM[];
}

export interface LineChartResponse {
    data?: LineChartViewMode[];
}

export interface LineChartViewMode {
    name?: string;
    series?: ResourceConsumptionDataRowVM[];
}

export interface ResourceConsumptionDataRowVM {
    name?: string;
    value?: number;
}

export interface ResourceSeriesResponse {
    siteId?: number;
    readingTypeId?: number;
    period?: string;
    unit?: string;
    aggregation?: SeriesAggregation;
    readingTypeAggregation?: SeriesAggregation;
    readingTypeName?: string;
    dateLeft?: Date;
    dateRight?: Date;
    solarConfig?: SolarConfigVM;
    tariffRates?: TariffRateVM[];
    siteMic?: SiteMicVM | undefined;
    measuredDemand?: MeasuredDemandVM;
    resolution?: string;
    series?: ResourceSeriesVM[];
    solarPerKwp?: ResourceSeriesPointVM[] | undefined;
    solarEstimateNote?: string | undefined;
    solarYearByDay?: number[] | undefined;
}

export enum SeriesAggregation {
    Sum = 0,
    Average = 1,
}

export interface SolarConfigVM {
    installedKwp?: number | undefined;
    panelWatts?: number | undefined;
    panelAreaM2?: number | undefined;
    usableRoofM2?: number | undefined;
    inverterAcKva?: number | undefined;
    mecKva?: number | undefined;
    micKva?: number | undefined;
    micCapacityChargeEurPerKvaYear?: number | undefined;
    importCentPerKwh?: number | undefined;
    exportCentPerKwh?: number | undefined;
    importDayCentPerKwh?: number | undefined;
    importWeekendDayCentPerKwh?: number | undefined;
    importNightCentPerKwh?: number | undefined;
    batteryCapacityKwh?: number | undefined;
    batteryUnitCount?: number | undefined;
    batteryChargeKw?: number | undefined;
    batteryDischargeKw?: number | undefined;
    batteryRoundTripPct?: number | undefined;
    batteryCostEur?: number | undefined;
    batteryCostPerKwhEur?: number | undefined;
    batteryAllowGridCharge?: boolean;
    batteryNightChargeToPct?: number | undefined;
    solarCostPerKwpEur?: number | undefined;
}

export interface MeasuredDemandVM {
    peakKva?: number;
    peakAt?: Date;
    peakHourMeanKva?: number;
    peakHourKwh?: number | undefined;
    sourceName?: string;
    hoursAtOrOverMic?: number;
    windowFrom?: Date;
    windowTo?: Date;
}

export interface ResourceSeriesVM {
    logicalGroupId?: number | undefined;
    seriesKey?: number | undefined;
    name?: string;
    rgb?: string;
    isTotal?: boolean;
    grossPositive?: number | undefined;
    grossNegative?: number | undefined;
    windowSum?: number | undefined;
    windowAverage?: number | undefined;
    windowMin?: number | undefined;
    windowMax?: number | undefined;
    valueTypeId?: number | undefined;
    unit?: string;
    interval?: string;
    points?: ResourceSeriesPointVM[];
}

export interface ResourceSeriesPointVM {
    date?: Date;
    label?: string;
    value?: number;
    sourceValue?: number | undefined;
}

export interface ChartLatestReadingVM {
    latest?: Date | undefined;
}

export interface LogicalGroupVM {
    logicalGroupId?: number;
    name?: string;
    readingTypeId?: number | undefined;
}

export interface CategoryLatestReadingsVM {
    fpcategoryId?: number;
    categoryName?: string;
    readings?: LogicalGroupReadingVM[];
}

export interface LogicalGroupReadingVM {
    logicalGroupId?: number;
    name?: string;
    readingTypeId?: number | undefined;
    unit?: string | undefined;
    value?: number | undefined;
    timestamp?: Date | undefined;
    isStale?: boolean;
    isIncomplete?: boolean;
    expectedChannelCount?: number;
    availableChannelCount?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}